import React from "react";
import { Row, Col, Avatar, Typography } from "antd";
import {
  CalendarOutlined,
  ClockCircleOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
  EnvironmentOutlined,
  BulbOutlined,
  BarChartOutlined,
  LinkOutlined,
} from "@ant-design/icons";
import styled from "styled-components";
import bgevent from "../../Assests/team-meeting-discussion-stockcake.jpg";
import Moderator from "../../Assests/moderator.svg";
import panel1 from "../../Assests/panel1.svg";
import panel2 from "../../Assests/panel2.svg";
import panel3 from "../../Assests/panel3.svg";
import panel4 from "../../Assests/panel4.svg";
import keynote from "../../Assests/keynote.svg";
import Foresyts from "../../Assests/Foresyts2.svg";
import qrImage from "../../Assests/qrimg.svg";
import footerlogo from "../../Assests/foresytsfooter.svg";
import footercontact from "../../Assests/footercontact.svg";
import Registerlink from "../../Assests/registerlink.svg";

const { Title, Text, Paragraph } = Typography;

const DESIGNED_FOR = [
  "CEOs & Managing Directors",
  "HR & People Leaders",
  "C Suite Executives",
  "Business Owners & Practice Leaders",
];

const HIGHLIGHTS = [
  "AI & The Evolving Workforce",
  "Building & Sustaining Respectful And Safe Workplaces",
  "Building High Performance Cultures",
  "Employee Engagement & Productivity",
  "Leadership In Changing Times",
];

const PANELISTS = [
  {
    name: "Sandeep Khapre",
    role: "CEO BDO East Africa",
    photo: panel1,
  },
  {
    name: "Neeru Maini",
    role: "Founder & CEO Foresyts, Australia & Africa Workforce Technology Specialist",
    photo: panel2,
  },
  {
    name: "Joram Nyanzi",
    role: "Managing Director Fracht Kenya Ltd",
    photo: panel3,
  },
  {
    name: "Maria Shipiri",
    role: "CEO ProsperMentor, HR Consultant & Board Member",
    photo: panel4,
  },
];

const Wrapper = styled.section`
  --ef-blue-dark: #0b1f8f;
  --ef-blue: #1e3fcb;
  --ef-gold: #f5a623;
  --ef-navy-text: #1a1f4d;
  --ef-muted: #6b7280;
  --ef-radius: 20px;

  font-family:
    "Inter",
    "Segoe UI",
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;
  display: flex;
  justify-content: center;
  padding: 32px 16px;
  background: #eef1fb;
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }
`;

const ContentFlex = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 24px;
  width: 100%;
  max-width: 880px;

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: stretch;
    max-width: 720px;
  }
`;

const Card = styled.div`
  width: 100%;
  max-width: 720px;
  background: #ffffff;
  border-radius: var(--ef-radius);
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(11, 31, 143, 0.18);
  border: 1px solid rgba(11, 31, 143, 0.08);
`;

const Header = styled.div`
  position: relative;
  min-height: 260px;
  padding: 32px 28px 60px;
  overflow: hidden;
  display: flex;
  align-items: flex-start;

  @media (max-width: 576px) {
    min-height: 220px;
    padding: 24px 20px 56px;
  }
`;

const HeaderBg = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    var(--ef-blue-dark) 0%,
    var(--ef-blue) 60%
  );
  clip-path: polygon(0 0, 62% 0, 45% 100%, 0 100%);
  z-index: 1;

  @media (max-width: 576px) {
    clip-path: none;
  }
`;

const HeaderImage = styled.div`
  position: absolute;
  inset: 0;
  background-image: url(${(props) => props.$src});
  background-size: 100% auto;
  background-position: center 20%; /* Move image down */
  clip-path: polygon(50% 0, 100% 0, 100% 100%, 33% 100%);

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      120deg,
      rgba(11, 31, 143, 0.35),
      rgba(11, 31, 143, 0.05)
    );
  }

  @media (max-width: 576px) {
    clip-path: none;
    opacity: 0.25;
  }
`;

const HeaderContent = styled.div`
  position: relative;
  z-index: 2;
  max-width: 62%;
  color: #fff;

  @media (max-width: 576px) {
    max-width: 100%;
  }
`;

const HeroTitle = styled(Title)`
  &.ant-typography {
    color: #fff;
    font-weight: 800;
    font-size: clamp(28px, 5vw, 36px);
    line-height: 1.1;
    margin: 0 0 12px;
  }
`;

const HeroSub = styled(Text)`
  &.ant-typography {
    display: block;
    color: #fff;
    font-weight: 700;
    font-style: italic;
    font-size: 16px;
    margin-bottom: 6px;
  }
`;

const HeroTagline = styled(Text)`
  &.ant-typography {
    display: block;
    color: #d9e0ff;
    font-style: italic;
    font-size: 13px;
  }
`;

const LogoBadge = styled.div`
  position: absolute;
  right: 50px;
  bottom: 20px;
  z-index: 3;
  background: #fff;
  border-radius: 10px;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  img {
    width: 80px;
  }
  @media (max-width: 576px) {
    right: 16px;
  }
`;

const InfoBar = styled.div`
  position: relative;
  z-index: 5;
  background: var(--ef-blue);
  padding: 28px 20px 16px;
  border-radius: 15px;
  border: 2px solid #fff;
  margin: -20px 30px 0px 30px;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  color: #fff;
`;

const InfoIcon = styled.span`
  width: 34px;
  height: 34px;
  min-width: 34px;
  border-radius: 50%;
  background: #fff;
  color: var(--ef-blue);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
`;

const InfoTop = styled(Text)`
  &.ant-typography {
    color: #fff;
    font-weight: 700;
    font-size: 14px;
  }
`;

const InfoBottom = styled(Text)`
  &.ant-typography {
    color: var(--ef-gold);
    font-weight: 600;
    font-size: 12px;
  }
`;

const Body = styled.div`
  padding: 28px 24px 8px;

  @media (max-width: 576px) {
    padding: 24px 16px 8px;
  }
`;

const SectionHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
`;

const RoundIcon = styled.span`
  width: 34px;
  height: 34px;
  min-width: 34px;
  border-radius: 50%;
  background: var(--ef-blue);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
`;

const SectionTitle = styled(Title)`
  &.ant-typography {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    color: var(--ef-navy-text);
  }
`;

const SectionCaption = styled(Text)`
  &.ant-typography {
    display: block;
    font-size: 12px;
    color: var(--ef-muted);
    margin-bottom: 4px;
  }
`;

const ListUl = styled.ul`
  margin: 8px 0 0;
  padding-left: 18px;
  color: var(--ef-navy-text);

  li {
    font-size: 13px;
    line-height: 1.6;
    margin-bottom: 4px;
  }

  li::marker {
    color: var(--ef-gold);
  }
`;

const VenueText = styled(Paragraph)`
  &.ant-typography {
    font-size: 13px;
    color: var(--ef-navy-text);
    margin: 0;
  }
`;

const LabelRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
`;

const PillTag = styled.span`
  flex: none;
  display: inline-block;
  background: var(--ef-gold);
  color: #fff;
  border-radius: 14px;
  padding: 4px 16px;
  font-weight: 700;
  font-size: 12px;
  white-space: nowrap;
`;

const DashedRule = styled.div`
  flex: 1;
  border-top: 1px dashed rgba(11, 31, 143, 0.25);
`;

const SpeakerRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 28px;
`;

const VerticalDivider = styled.div`
  width: 1px;
  align-self: stretch;
  background: rgba(11, 31, 143, 0.15);
`;

const SpeakerName = styled(Text)`
  &.ant-typography {
    font-weight: 700;
    font-size: 14px;
    color: var(--ef-blue);
  }
`;

const SpeakerRole = styled(Text)`
  &.ant-typography {
    font-size: 12px;
    color: var(--ef-navy-text);
  }
`;

const PanelRow = styled(Row)`
  &.ant-row {
    margin-bottom: 28px !important;
  }
`;

const PanelCol = styled(Col)`
  text-align: center;
`;

const PanelAvatar = styled(Avatar)`
  margin-bottom: 8px;
`;

const PanelName = styled(SpeakerName)`
  &.ant-typography {
    font-size: 12px;
    display: block;
  }
`;

const PanelRole = styled(SpeakerRole)`
  &.ant-typography {
    font-size: 11px;
    display: block;
  }
`;

const ValueRow = styled(Row)`
  &.ant-row {
    border-top: 1px solid rgba(11, 31, 143, 0.1);
    padding-top: 20px;
    margin-top: 12px !important;
  }
`;

const ValueItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  color: var(--ef-navy-text);
  font-weight: 600;
`;

const ValueIcon = styled.span`
  color: var(--ef-gold);
  font-size: 20px;
  display: inline-flex;
`;

const Footer = styled.div`
  background: #2d53da;
  border-top: 3px solid #f5c542;
`;

const FooterHeading = styled.div`
  font-size: 12px;
  color: #fff;
  font-weight: 600;
`;

const DividerCol = styled(Col)`
  border-right: 1px solid rgba(255, 255, 255, 0.3);

  &:last-child {
    border-right: none;
  }
`;

/* Floating RSVP / Register button group — sits beside the card on desktop,
   stacks back under it on smaller screens. */
const RegisterBanner = styled.div`
  flex: 0 0 auto;
  width: 200px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-family: "Inter", sans-serif;

  position: relative;
  top: 50%;

  @media (max-width: 900px) {
    position: static;
    width: 100%;
    max-width: 340px;
    margin: 24px auto 0;
  }
`;

const RSVPButton = styled.div`
  background: #e9b929;
  color: #1a1f4d;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  padding: 10px 20px;
  border-radius: 999px;

  font-size: 15px;
  font-weight: 800;
  letter-spacing: 0.3px;

  box-shadow: 0 4px 10px rgba(233, 185, 41, 0.35);

  @media (max-width: 480px) {
    font-size: 13px;
    padding: 9px 16px;
  }
`;

const l = styled.a`
  background: #3153d7;
  color: #fff;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  padding: 10px 20px;
  border-radius: 999px;

  text-decoration: none;
  font-size: 15px;
  font-weight: 700;

  box-shadow: 0 4px 10px rgba(49, 83, 215, 0.35);

  &:hover {
    color: #fff;
    background: #2a47bf;
  }

  @media (max-width: 480px) {
    font-size: 13px;
    padding: 9px 16px;
  }
`;

const EventForum = ({ logoText = "Foresyts" }) => {
  return (
    <Wrapper>
      <ContentFlex>
        <Card>
          <Header>
            <HeaderBg />
            <HeaderImage $src={bgevent} />
            <HeaderContent>
              <HeroTitle level={1}>
                The Future Of
                <br />
                Workplace
              </HeroTitle>
              <HeroSub>AI, Culture &amp; Leadership</HeroSub>
              <HeroTagline>An Executive Forum</HeroTagline>
            </HeaderContent>

            <LogoBadge>
              <img src={Foresyts} alt="logo" />
            </LogoBadge>
          </Header>

          <InfoBar>
            <Row gutter={[16, 12]} justify="center" align="middle">
              {[
                {
                  icon: <CalendarOutlined />,
                  top: "Saturday",
                  bottom: "25 July 2026",
                },
                {
                  icon: <ClockCircleOutlined />,
                  top: "9:45 am",
                  bottom: "Registration",
                },
                {
                  icon: <ClockCircleOutlined />,
                  top: "12:30 pm",
                  bottom: "Networking Lunch",
                },
              ].map((item, i) => (
                <Col xs={24} sm={8} key={i}>
                  <InfoItem>
                    <InfoIcon>{item.icon}</InfoIcon>
                    <span>
                      <InfoTop>{item.top}</InfoTop>
                      <br />
                      <InfoBottom>{item.bottom}</InfoBottom>
                    </span>
                  </InfoItem>
                </Col>
              ))}
            </Row>
          </InfoBar>

          <Body>
            <Row gutter={[32, 32]}>
              <Col xs={24} md={9}>
                <div
                  style={{
                    background: "rgba(240, 243, 255, 1)",
                    borderRadius: "15px",
                    padding: "10px",
                  }}
                >
                  <SectionHeading>
                    <RoundIcon>
                      <TeamOutlined />
                    </RoundIcon>
                    <SectionTitle level={4}>Designed For</SectionTitle>
                  </SectionHeading>
                  <ListUl>
                    {DESIGNED_FOR.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ListUl>
                </div>
                <br />
                <div
                  style={{
                    background: "rgba(240, 243, 255, 1)",
                    borderRadius: "15px",
                    padding: "10px",
                  }}
                >
                  <SectionHeading>
                    <RoundIcon>
                      <UsergroupAddOutlined />
                    </RoundIcon>
                    <SectionTitle level={4}>Event Highlights</SectionTitle>
                  </SectionHeading>
                  <SectionCaption>
                    Key address and discussion on below:
                  </SectionCaption>
                  <ListUl>
                    {HIGHLIGHTS.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ListUl>
                </div>
                <br />
                <div
                  style={{
                    background: "rgba(240, 243, 255, 1)",
                    borderRadius: "15px",
                    padding: "10px",
                  }}
                >
                  <SectionHeading>
                    <RoundIcon>
                      <EnvironmentOutlined />
                    </RoundIcon>
                    <SectionTitle level={4}>Venue</SectionTitle>
                  </SectionHeading>
                  <VenueText>
                    Floor 8, The Westwood
                    <br />
                    Off Ring Road, Westlands
                  </VenueText>
                </div>
              </Col>

              <Col xs={24} md={15}>
                <LabelRow>
                  <PillTag>Keynote Speaker</PillTag>
                  <DashedRule />
                </LabelRow>
                <SpeakerRow>
                  <Avatar size={72} src={keynote} />
                  <div>
                    <SpeakerName>Jacqueline Mugo</SpeakerName>
                    <br />
                    <SpeakerRole>
                      Executive Director &amp; CEO
                      <br />
                      Federation Of Kenya Employers
                    </SpeakerRole>
                  </div>
                </SpeakerRow>

                <LabelRow>
                  <PillTag>Panel Speakers</PillTag>
                  <DashedRule />
                </LabelRow>
                <PanelRow gutter={[16, 20]}>
                  {PANELISTS.map((p) => (
                    <PanelCol xs={12} sm={6} key={p.name}>
                      <PanelAvatar size={72} src={p.photo} />
                      <br />
                      <PanelName>{p.name}</PanelName>
                      <br />
                      <PanelRole>{p.role}</PanelRole>
                    </PanelCol>
                  ))}
                </PanelRow>

                <LabelRow>
                  <PillTag>Moderator</PillTag>
                  <DashedRule />
                </LabelRow>
                <SpeakerRow>
                  <Avatar size={72} src={Moderator} />
                  <VerticalDivider />
                  <div>
                    <SpeakerName>Maureen Onyango</SpeakerName>
                    <br />
                    <SpeakerRole>
                      Board Advisor &amp; Director Marketing, Foresyts.
                    </SpeakerRole>
                  </div>
                </SpeakerRow>
              </Col>
            </Row>

            <ValueRow gutter={[16, 16]}>
              {[
                {
                  icon: <UsergroupAddOutlined style={{ color: "#2D53DA" }} />,
                  label: "Network with industry leaders",
                },
                {
                  icon: <BulbOutlined style={{ color: "#2D53DA" }} />,
                  label: "Gain actionable insights",
                },
                {
                  icon: <BarChartOutlined style={{ color: "#2D53DA" }} />,
                  label: "Shape the future of work",
                },
              ].map((item, i) => (
                <Col xs={24} sm={8} key={i}>
                  <ValueItem>
                    <ValueIcon>{item.icon}</ValueIcon>
                    <Text>{item.label}</Text>
                  </ValueItem>
                </Col>
              ))}
            </ValueRow>
          </Body>

          <Footer>
            <Row align="middle">
              <DividerCol xs={24} md={8}>
                <div style={{ padding: "12px 18px" }}>
                  <FooterHeading>Visit:</FooterHeading>
                  <img
                    src={footerlogo}
                    style={{ cursor: "pointer" }}
                    alt="footerlogo"
                    onClick={() =>
                      window.open(
                        "https://www.foresyts.ai/",
                        "_blank",
                        "noopener,noreferrer",
                      )
                    }
                  />
                </div>
              </DividerCol>

              <DividerCol xs={24} md={8}>
                <div
                  style={{
                    padding: "12px 18px",
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                  }}
                >
                  <img
                    src={qrImage}
                    alt="QR"
                    style={{
                      width: 60,
                      height: 60,
                      background: "#fff",
                      padding: 4,
                    }}
                  />

                  <div>
                    <div
                      style={{
                        color: "#FFD54A",
                        fontWeight: 700,
                      }}
                    >
                      Scan to RSVP
                    </div>

                    <div
                      style={{
                        color: "#fff",
                        fontSize: 13,
                      }}
                    >
                      Quick. Easy
                      <br />
                      Secure your spot
                    </div>
                  </div>
                </div>
              </DividerCol>

              <DividerCol xs={24} md={8}>
                <div style={{ padding: "12px 18px" }}>
                  <FooterHeading>Visit:</FooterHeading>
                  <img src={footercontact} alt="footercontact" />
                </div>
              </DividerCol>
            </Row>
          </Footer>
        </Card>

        <RegisterBanner>
          <a
            href="https://forms.gle/MSsiaa3TcXjBi7kG8"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Registerlink} alt="Register for the event" />
          </a>
        </RegisterBanner>
      </ContentFlex>
    </Wrapper>
  );
};

export default EventForum;
